import { render, staticRenderFns } from "./reports-index.vue?vue&type=template&id=6fc40c8e&scoped=true"
import script from "./reports-index.vue?vue&type=script&lang=js"
export * from "./reports-index.vue?vue&type=script&lang=js"
import style0 from "./reports-index.vue?vue&type=style&index=0&id=6fc40c8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc40c8e",
  null
  
)

export default component.exports